// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
/*#region Text*/
/*#endregion */
/*#region Elements*/
/**#region Event Container */
/*#endregion*/
/*#endregion */
/* #region Screen */
/* #endregion*/
.template-requirement-message {
  color: #eec9c9;
  font-size: 12px;
  margin: 8px 0 0 0;
}

ul {
  margin: 0 0 6px 0;
  max-height: 100px;
  overflow-y: auto;
}
ul::-webkit-scrollbar {
  width: 10px;
}
ul::-webkit-scrollbar-track {
  background: #24384a;
}
ul::-webkit-scrollbar-thumb {
  background: #15202b;
  border-radius: 10px;
}
ul li {
  margin-bottom: 10px;
}

.alert-options-container {
  width: 100%;
}
.alert-options-container .flexbox {
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert-options-container .flexbox ::ng-deep.dropdown.small {
  width: 285px;
}

.announcement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.announcement-header .add-announcement-btn {
  background-color: transparent;
  color: #52aaff;
  font-size: 14px;
}
.announcement-header .add-announcement-btn.disabled {
  cursor: not-allowed;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
